import React, { useState, useEffect } from 'react';
import SalesProfiles from './SalesProfiles';
import KnowledgeManager from './KnowledgeManager';
import AISettings from './AISettings';
import OrdersSettings from './OrdersSettings';
import axios from 'axios';
import LiveAlertBar from './LiveAlertBar';
import { loadOrderNumberSource, setOrderNumberSourceCache, useOrderNumberSource } from './orderNumberPref';

function OrderNumberPrefCard() {
  const src = useOrderNumberSource();
  const [msg, setMsg] = React.useState('');
  const save = (v: string) => {
    setMsg('');
    axios.put('/api/ok-crm/prefs', { order_number_source: v })
      .then(() => { setOrderNumberSourceCache(v === 'ok' ? 'ok' : 'apilo'); loadOrderNumberSource(true); setMsg('✓ Zapisano'); window.setTimeout(() => setMsg(''), 2500); })
      .catch(() => setMsg('Nie udało się zapisać'));
  };
  return (
    <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 10, padding: 16, marginBottom: 16 }}>
      <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>Numer zamówienia w Wiadomościach, Issues i Zwrotach</div>
      <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 10 }}>Który numer zamówienia pokazywać przy zamówieniach klienta. Ustawienie dotyczy tylko Twojego konta.</div>
      <div style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
        <label style={{ fontSize: 13, display: 'flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}><input type="radio" checked={src === 'apilo'} onChange={() => save('apilo')} /> Apilo (AM…)</label>
        <label style={{ fontSize: 13, display: 'flex', gap: 6, alignItems: 'center', cursor: 'pointer' }}><input type="radio" checked={src === 'ok'} onChange={() => save('ok')} /> OPENkontakt (OK…)</label>
        {msg ? <span style={{ fontSize: 12, color: msg.startsWith('✓') ? '#059669' : '#dc2626' }}>{msg}</span> : null}
      </div>
    </div>
  );
}

const API = '/api';

interface ImapAccount { id: string; name: string; host: string; port: string; login: string; active: boolean; smtp_host?: string; smtp_port?: string; }
interface AllegroAccount { id: string; name: string; expires_at: string; }
interface UserAccount { id: string; name: string; email: string; role: string; active: boolean; modules: string[]; color?: string; can_assign?: boolean; can_cross_publish?: boolean; phone?: string; }

export default function Settings({ onBack, hideHeader, currentUser, onOpenAiOpen = () => {}, onOpenReturns = () => {} }: { onBack: () => void; hideHeader?: boolean; currentUser?: {name:string, email:string, role:string, modules:string[], can_assign?: boolean, color?: string} | null; onOpenAiOpen?: () => void; onOpenReturns?: () => void }) {
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [refreshKey, setRefreshKey] = useState(0);
  const isAdminInit = currentUser?.role === 'admin';
  const [tab, setTab] = useState(isAdminInit ? 'allegro' : 'profile');
  const [mobileTabSelected, setMobileTabSelected] = useState(false);
  const setTabWithContext = (t: string) => { setTab(t); setMobileTabSelected(true); localStorage.setItem('assistant_context', 'settings:' + t); };
  const [imapAccounts, setImapAccounts] = useState<ImapAccount[]>([]);
  const [imapTestResult, setImapTestResult] = useState<{status:string,message:string,detected_host?:string,detected_port?:string}|null>(null);
  const [imapTesting, setImapTesting] = useState(false);
  const [imapDetectedHost, setImapDetectedHost] = useState('');
  const [imapDetectedPort, setImapDetectedPort] = useState('993');
  const [imapDetectedSmtpHost, setImapDetectedSmtpHost] = useState('');
  const [imapDetectedSmtpPort, setImapDetectedSmtpPort] = useState('587');
  const [editingImap, setEditingImap] = useState<string|null>(null);
  const [editImap, setEditImap] = useState({name:'',host:'',port:'993',login:'',password:'',smtp_host:'',smtp_port:'587'});
  const [allegroAccounts, setAllegroAccounts] = useState<AllegroAccount[]>([]);
  const [users, setUsers] = useState<UserAccount[]>([]);
  const [appSettings, setAppSettings] = useState<Record<string,string>>({});
  const [saved, setSaved] = useState('');
  const [newImap, setNewImap] = useState({ name: '', host: 'mail.lh.pl', port: '993', login: '', password: '', smtp_host: '', smtp_port: '587' });
  const [newUser, setNewUser] = useState({ name: '', email: '', password: '', role: 'agent', phone: '' });
  const [newUserModules, setNewUserModules] = useState<string[]>(['issues', 'messages', 'aiopen', 'offers', 'settings']);
  const [editingUser, setEditingUser] = useState<string | null>(null);
  const [editUserModules, setEditUserModules] = useState<string[]>([]);
  const [editUserColor, setEditUserColor] = useState<string>('#6b7280');
  const [editUserCanAssign, setEditUserCanAssign] = useState<boolean>(false);
  const [editUserCanCrossPublish, setEditUserCanCrossPublish] = useState<boolean>(false);
  const [editUserPhone, setEditUserPhone] = useState<string>('');
  const [emailRules, setEmailRules] = useState<any[]>([]);
  const [showAddRule, setShowAddRule] = useState(false);
  const [newRule, setNewRule] = useState({ name: '', account_id: '', logic: 'AND', conditions: [{field:'sender',operator:'contains',value:''}], assigned_to: '' });
  const [ruleAgents, setRuleAgents] = useState<{id:string,name:string,color?:string}[]>([]);
  const [workHours, setWorkHours] = useState<{start:string,end:string,days:number[]}>({ start: '08:00', end: '16:00', days: [0,1,2,3,4] });
  const [autoReply, setAutoReply] = useState('');
  const [crawlUrl, setCrawlUrl] = useState('');
  const [crawlStatus, setCrawlStatus] = useState('');
  const [faqText, setFaqText] = useState('');
  const [faqStatus, setFaqStatus] = useState('');
  const [templates, setTemplates] = useState<any[]>([]);
  const [templateName, setTemplateName] = useState('');
  const [templateText, setTemplateText] = useState('');
  const [templateCategory, setTemplateCategory] = useState('return');
  const [shortcuts, setShortcuts] = useState<any[]>([]);
  const [shortcutName, setShortcutName] = useState('');
  const [shortcutText, setShortcutText] = useState('');
  const [editingShortcut, setEditingShortcut] = useState<any>(null);
  const [templateStatus, setTemplateStatus] = useState('');
  const [editingTemplate, setEditingTemplate] = useState<any>(null);
  const [changePass, setChangePass] = useState({ old_password: '', new_password: '', confirm: '' });
  const LANG_LABELS: Record<string, string> = {
    en: 'angielski', de: 'niemiecki', cs: 'czeski', sk: 'słowacki', ro: 'rumuński', hu: 'węgierski',
    uk: 'ukraiński', ru: 'rosyjski', fr: 'francuski', it: 'włoski', es: 'hiszpański', nl: 'holenderski',
    bg: 'bułgarski', el: 'grecki', sv: 'szwedzki', lt: 'litewski', lv: 'łotewski', et: 'estoński',
  };
  const [footer, setFooter] = useState({ enabled: false, text: '', translations: {} as Record<string, string> });
  const [footerMeta, setFooterMeta] = useState({ default_text: '', account_name: 'Sklep' });
  const [footerStatus, setFooterStatus] = useState('');
  const [passStatus, setPassStatus] = useState('');
  const [assistantMobile, setAssistantMobile] = useState<boolean>(() => {
    const val = localStorage.getItem('assistant_enabled_mobile');
    return val === null ? true : val === 'true';
  });
  const [assistantDesktop, setAssistantDesktop] = useState<boolean>(() => {
    const val = localStorage.getItem('assistant_enabled_desktop');
    return val === null ? true : val === 'true';
  });

  useEffect(() => {
    loadAll();
    loadRules();
    localStorage.setItem('assistant_context', 'settings:' + (isAdminInit ? 'allegro' : 'profile'));
    return () => { localStorage.removeItem('assistant_context'); };
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const loadAll = async () => {
    const safe = (p: Promise<any>) => p.catch(() => null);
    const [imap, allegro, usr, settings, tmpl, sc] = await Promise.all([
      safe(axios.get(API + '/settings/imap-accounts')),
      safe(axios.get(API + '/allegro/accounts')),
      safe(axios.get('/auth/users')),
      safe(axios.get(API + '/settings/app')),
      safe(axios.get(API + '/settings/reply-templates')),
      safe(axios.get(API + '/shortcuts')),
    ]);
    if (imap) setImapAccounts(imap.data);
    if (allegro) setAllegroAccounts(allegro.data);
    if (usr) setUsers(usr.data);
    if (settings) {
      setAppSettings(settings.data);
      if (settings.data.work_start) setWorkHours({ start: settings.data.work_start, end: settings.data.work_end || '16:00', days: settings.data.work_days ? settings.data.work_days.split(',').filter((x:string)=>x.trim()!=='').map(Number) : [0,1,2,3,4] });
      if (settings.data.auto_reply) setAutoReply(settings.data.auto_reply);
    }
    if (tmpl) setTemplates(tmpl.data.templates || []);
    if (sc) setShortcuts(sc.data.shortcuts || []);
  };

  const showSaved = (msg: string) => { setSaved(msg); setTimeout(() => setSaved(''), 3000); };
  const loadRules = async () => {
    try { const r = await axios.get(API + '/email/rules'); setEmailRules(r.data); } catch(e) {}
    try { const a = await axios.get('/api/agents'); setRuleAgents(a.data); } catch(e) {}
  };

  const addImap = async () => {
    if (!newImap.login || !newImap.password) return;
    await axios.post(API + '/settings/imap-accounts', newImap);
    setNewImap({ name: '', host: 'mail.lh.pl', port: '993', login: '', password: '', smtp_host: '', smtp_port: '587' });
    setImapDetectedSmtpHost(''); setImapDetectedSmtpPort('587');
    loadAll();
    showSaved('Konto IMAP dodane');
  };

  const saveEditImap = async (id: string) => {
    try {
      await axios.patch(API + '/settings/imap-accounts/' + id, editImap);
      setEditingImap(null);
      showSaved('Konto zaktualizowane');
      loadAll();
    } catch (e: any) {
      alert('Blad zapisu: ' + (e.response?.data?.detail || 'nieznany'));
    }
  };
  const testImap = async () => {
    setImapTesting(true);
    setImapTestResult(null);
    setImapDetectedHost('');
    try {
      const payload = imapDetectedHost
        ? { ...newImap, host: imapDetectedHost, port: imapDetectedPort }
        : { ...newImap, host: newImap.host || 'auto' };
      const res = await axios.post(API + '/email/detect-config', payload);
      setImapTestResult(res.data);
      if (res.data.detected_host) {
        setImapDetectedHost(res.data.detected_host);
        setImapDetectedPort(res.data.detected_port || '993');
        setImapDetectedSmtpHost(res.data.detected_smtp_host || '');
        setImapDetectedSmtpPort(res.data.detected_smtp_port || '587');
        setNewImap(prev => ({...prev, host: res.data.detected_host, port: res.data.detected_port || '993',
          smtp_host: res.data.detected_smtp_host || '', smtp_port: res.data.detected_smtp_port || '587'}));
      }
    } catch (e: any) {
      setImapTestResult({status: 'error', message: e.response?.data?.detail || 'Blad polaczenia'});
    }
    setImapTesting(false);
  };
  const deleteImap = async (id: string) => {
    await axios.delete(API + '/settings/imap-accounts/' + id);
    loadAll();
  };

  const deleteAllegro = async (id: string) => {
    await axios.delete(API + '/settings/allegro-accounts/' + id);
    loadAll();
  };

  const renameAllegro = async (id: string, name: string) => {
    await axios.put(API + '/settings/allegro-accounts/' + id + '/name', { value: name });
    loadAll();
    showSaved('Nazwa konta zaktualizowana');
  };

  const addUser = async () => {
    if (!newUser.email || !newUser.password) return;
    try {
      await axios.post('/auth/users', { ...newUser, modules: newUserModules });
      setNewUser({ name: '', email: '', password: '', role: 'agent', phone: '' });
      setNewUserModules(['issues', 'messages', 'aiopen', 'offers', 'settings']);
      loadAll();
      showSaved('Uzytkownik dodany');
    } catch (e: any) { showSaved(e.response?.data?.detail || 'Blad dodawania'); }
  };

  const saveUserModules = async (id: string, modules: string[]) => {
    await axios.patch('/auth/users/' + id, { modules, color: editUserColor, can_assign: editUserCanAssign, can_cross_publish: editUserCanCrossPublish, phone: editUserPhone });
    setEditingUser(null);
    loadAll();
    showSaved('Uprawnienia zaktualizowane');
  };

  const toggleMod = (list: string[], mod: string) =>
    list.includes(mod) ? list.filter(m => m !== mod) : [...list, mod];

  const ALL_MODULES = [
    { id: 'messages', label: 'Kontakt' },
    { id: 'offers', label: 'Oferty' },
    { id: 'issues', label: 'Issues / Odrzucone' },
    { id: 'aiopen', label: 'AI OPEN' },
    { id: 'settings', label: 'Ustawienia' },
    { id: 'orders', label: 'Zamówienia' },
  ];

  const deleteUser = async (id: string) => {
    await axios.delete('/auth/users/' + id);
    loadAll();
  };

  const saveWorkHours = async () => {
    await Promise.all([
      axios.post(API + '/settings/app/work_start', { value: workHours.start }),
      axios.post(API + '/settings/app/work_end', { value: workHours.end }),
      axios.post(API + '/settings/app/work_days', { value: workHours.days.slice().sort((a,b)=>a-b).join(',') }),
    ]);
    showSaved('Godziny pracy zapisane');
  };

  const saveAutoReply = async () => {
    await axios.post(API + '/settings/app/auto_reply', { value: autoReply });
    showSaved('Auto-odpowiedz zapisana');
  };

  const runCrawler = async () => {
    setCrawlStatus('Skanowanie strony...');
    try {
      const res = await axios.post(API + '/admin/crawl', { url: crawlUrl });
      setCrawlStatus('Zeskanowano ' + res.data.total + ' podstron. Wiedza zaktualizowana.');
      loadAll();
    } catch (e) { setCrawlStatus('Blad skanowania'); }
  };

  const uploadFaq = async () => {
    if (!faqText.trim()) return;
    setFaqStatus('Importowanie...');
    try {
      const blob = new Blob([faqText], { type: 'text/plain' });
      const formData = new FormData();
      formData.append('file', blob, 'faq.txt');
      const res = await axios.post(API + '/settings/knowledge/upload-file', formData, {
        headers: { 'Content-Type': 'multipart/form-data' }
      });
      setFaqStatus('Zaimportowano ' + res.data.added + ' wpisow, pominięto ' + res.data.skipped + ' duplikatow.');
      setFaqText('');
      loadAll();
    } catch (e) { setFaqStatus('Blad importu'); }
  };

  useEffect(() => {
    axios.get(`${API}/users/me/footer`).then(r => {
      setFooter({ enabled: !!r.data?.enabled, text: r.data?.text || r.data?.default_text || '', translations: r.data?.translations || {} });
      setFooterMeta({ default_text: r.data?.default_text || '', account_name: r.data?.account_name || 'Sklep' });
    }).catch(() => {});
  }, []);

  const saveFooter = async () => {
    if (footer.enabled && !footer.text.trim()) { setFooterStatus('W\u0142\u0105czona stopka nie mo\u017ce by\u0107 pusta'); return; }
    try {
      setFooterStatus('Tłumaczę stopkę na wszystkie języki...');
      const r = await axios.put(`${API}/users/me/footer`, { enabled: footer.enabled, text: footer.text });
      setFooter(f => ({ ...f, translations: r.data?.translations || {} }));
      setFooterStatus('\u2713 Zapisano stopk\u0119');
      setTimeout(() => setFooterStatus(''), 2500);
    } catch (e:any) {
      setFooterStatus(e?.response?.data?.detail || 'B\u0142\u0105d zapisu stopki');
    }
  };

  const changePassword = async () => {
    if (!changePass.old_password || !changePass.new_password) { setPassStatus('Wypełnij wszystkie pola'); return; }
    if (changePass.new_password !== changePass.confirm) { setPassStatus('Hasła nie są identyczne'); return; }
    if (changePass.new_password.length < 8) { setPassStatus('Hasło musi mieć minimum 8 znaków'); return; }
    try {
      await axios.post(API + '/auth/change-password', {
        old_password: changePass.old_password,
        new_password: changePass.new_password
      });
      setPassStatus('Hasło zmienione pomyślnie!');
      setChangePass({ old_password: '', new_password: '', confirm: '' });
      setTimeout(() => setPassStatus(''), 3000);
    } catch (e: any) {
      setPassStatus(e.response?.data?.detail || 'Błąd zmiany hasła');
    }
  };

  const isAdmin = currentUser?.role === 'admin';
  const allTabs = [
    { id: 'allegro', label: 'Konta Allegro', adminOnly: true },
    { id: 'imap', label: 'Konta Email', adminOnly: true },
    { id: 'knowledge', label: 'Baza wiedzy', adminOnly: false },
    { id: 'hours', label: 'Godziny pracy', adminOnly: true },
    { id: 'users', label: 'Uzytkownicy', adminOnly: true },
    { id: 'profile', label: 'Moje konto', adminOnly: false },
    { id: 'templates', label: 'Wzory odpowiedzi', adminOnly: false },
    { id: 'shortcuts', label: 'Skróty #', adminOnly: false },
    { id: 'ai', label: 'Konfiguracja AI', adminOnly: true },
    { id: 'orders-settings', label: 'Zamówienia', adminOnly: true },
    { id: 'offers', label: 'Oferty', adminOnly: true },
    { id: 'returns-alert', label: 'Zwroty', adminOnly: true },
    { id: 'sales-profiles', label: 'Profil sprzedażowy', adminOnly: true },
    { id: 'asystent', label: 'Asystent', adminOnly: false },
  ];
  const tabs = allTabs.filter(t => !t.adminOnly || isAdmin);

  const s = {
    input: { width: '100%', padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, boxSizing: 'border-box' as const, fontFamily: 'system-ui' },
    btn: { padding: '7px 14px', borderRadius: 6, border: 'none', fontSize: 13, cursor: 'pointer', fontWeight: 500 as const },
    btnPrimary: { background: '#1d4ed8', color: '#fff' },
    btnDanger: { background: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5' },
    btnGreen: { background: '#f0fdf4', color: '#15803d', border: '1px solid #bbf7d0' },
    card: { background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 16, marginBottom: 12 },
    label: { fontSize: 12, color: '#6b7280', marginBottom: 4, display: 'block' as const },
    row: { display: 'flex', gap: 8, alignItems: 'flex-end' as const, flexWrap: 'wrap' as const },
  };

  return (
    <div style={{ display: 'flex', flexDirection: 'column' as const, height: hideHeader ? '100%' : '100dvh', fontFamily: 'system-ui, sans-serif', fontSize: 14 }}>
      {!hideHeader && <LiveAlertBar currentUser={currentUser} onOpenAiOpen={onOpenAiOpen} onOpenReturns={onOpenReturns} />}
      <div style={{ display: 'flex', flexDirection: window.innerWidth < 768 ? 'column' as const : 'row' as const, flex: 1, minHeight: 0 }}>
      <div style={{ width: 220, borderRight: '1px solid #e5e7eb', background: '#f9fafb', display: window.innerWidth < 768 ? 'none' : 'flex', flexDirection: 'column', flexShrink: 0 }}>
        <div style={{ padding: '8px 12px', borderBottom: '1px solid #e5e7eb' }}>
          <button onClick={onBack} style={{ width: '100%', padding: '8px', background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>
            ← Strona główna
          </button>
        </div>
        <div style={{ padding: '8px 0' }}>
          {tabs.map(t => (
            <div key={t.id} onClick={() => { setTabWithContext(t.id); setRefreshKey(k => k+1); loadAll(); }}
              style={{ padding: '10px 16px', cursor: 'pointer', fontSize: 13,
                background: tab === t.id ? '#eff6ff' : 'transparent',
                color: tab === t.id ? '#1d4ed8' : '#374151',
                fontWeight: tab === t.id ? 500 : 400,
                borderLeft: tab === t.id ? '3px solid #1d4ed8' : '3px solid transparent' }}>
              {t.label}
            </div>
          ))}
        </div>
      </div>

      {/* MOBILE: lista zakładek */}
      {window.innerWidth < 768 && !mobileTabSelected && (
        <div style={{ flex: 1, background: '#fff', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <div style={{ padding: '12px 16px', background: '#1d4ed8', color: '#fff', fontSize: 15, fontWeight: 600 }}>Ustawienia</div>
          <div style={{ flex: 1, overflowY: 'auto' }}>
            {tabs.map(t => (
              <div key={t.id} onClick={() => { setTabWithContext(t.id); setRefreshKey(k => k+1); loadAll(); }}
                style={{ padding: '14px 16px', borderBottom: '1px solid #e5e7eb', cursor: 'pointer',
                  fontSize: 14, color: '#374151', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                {t.label}
                <span style={{ color: '#9ca3af', fontSize: 18 }}>›</span>
              </div>
            ))}
          </div>
        </div>
      )}
      {/* MOBILE: zawartość wybranej zakładki */}
      {(window.innerWidth >= 768 || mobileTabSelected) && (
        <div style={{ flex: 1, background: '#f9fafb', display: 'flex', flexDirection: 'column', overflow: 'hidden' }}>
          <div style={{ padding: '10px 16px', background: '#1d4ed8', color: '#fff', display: 'flex', alignItems: 'center', gap: 10, flexShrink: 0 }}>
            <button onClick={() => setMobileTabSelected(false)} style={{ background: 'none', border: 'none', color: '#fff', fontSize: 20, cursor: 'pointer', padding: 0 }}>←</button>
            <span style={{ fontSize: 14, fontWeight: 500 }}>{tabs.find(t2 => t2.id === tab)?.label}</span>
          </div>
          <div style={{ flex: 1, overflowY: 'auto', padding: 16, paddingBottom: 95 }}>
      <div style={{ flex: 1, overflowY: 'auto', padding: 24, paddingBottom: hideHeader ? 95 : 24, background: '#f9fafb' }}>
        {saved && (
          <div style={{ padding: '10px 14px', background: '#f0fdf4', color: '#15803d', borderRadius: 6, fontSize: 13, marginBottom: 16, border: '1px solid #bbf7d0' }}>
            {saved}
          </div>
        )}

        {tab === 'allegro' && (
          <div>
            <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>Konta Allegro</h2>
            {allegroAccounts.length === 0 && (
              <div style={{ ...s.card, color: '#6b7280', fontSize: 13 }}>Brak podlaczonych kont Allegro.</div>
            )}
            {allegroAccounts.map(a => (
              <div key={a.id} style={s.card}>
                <div style={s.row}>
                  <div style={{ flex: 1 }}>
                    <label style={s.label}>Nazwa konta</label>
                    <input defaultValue={a.name} style={s.input} onBlur={e => renameAllegro(a.id, e.target.value)} />
                  </div>
                  <div style={{ flex: 1 }}>
                    <label style={s.label}>Token wygasa</label>
                    <div>
                      <div style={{ fontSize: 12, padding: '7px 0',
                        color: a.expires_at && new Date(a.expires_at + (a.expires_at.includes("Z") ? "" : "Z")) < new Date() ? '#dc2626' : '#15803d',
                        fontWeight: a.expires_at && new Date(a.expires_at + (a.expires_at.includes("Z") ? "" : "Z")) < new Date() ? 600 : 400 }}>
                        {a.expires_at && new Date(a.expires_at + (a.expires_at.includes("Z") ? "" : "Z")) < new Date() ? '⚠️ WYGASŁY - ' : '✓ '}
                        {a.expires_at ? new Date(a.expires_at + (a.expires_at.includes("Z") ? "" : "Z")).toLocaleString('pl-PL') : 'Brak danych'}
                      </div>
                      {a.expires_at && new Date(a.expires_at + (a.expires_at.includes("Z") ? "" : "Z")) < new Date() && (
                        <div style={{ fontSize: 11, color: '#9b1c1c', lineHeight: 1.8, marginTop: 4, padding: '8px 10px', background: '#fef2f2', borderRadius: 6, border: '1px solid #fecaca' }}>
                          <div style={{ fontWeight: 600, marginBottom: 4 }}>Aby odświeżyć:</div>
                          <div>1) Zaloguj się w przeglądarce na konto Allegro <strong>{a.name}</strong></div>
                          <div>2) Kliknij 🔄</div>
                        </div>
                      )}
                    </div>
                  </div>
                  <a href={'/api/allegro/login?account_name=' + encodeURIComponent(a.name) + '&token=' + (localStorage.getItem('token') || '')}
                    style={{ ...s.btn, padding: '6px 10px', background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: 6, fontSize: 12, cursor: 'pointer', textDecoration: 'none', whiteSpace: 'nowrap' }}>
                    🔄 Odśwież
                  </a>
                  <button onClick={() => deleteAllegro(a.id)} style={{ ...s.btn, ...s.btnDanger }}>Usun</button>
                </div>
              </div>
            ))}
            <div style={s.card}>
              <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 12 }}>
                Po kliknięciu zostaniesz przekierowany do Allegro w celu autoryzacji.
              </div>
              <button onClick={() => { window.location.href = '/api/allegro/login?token=' + (localStorage.getItem('token') || ''); }}
                style={{ ...s.btn, ...s.btnPrimary }}>
                + Dodaj konto Allegro
              </button>
            </div>
          </div>
        )}

        {tab === 'imap' && (
          <div>
            <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>Konta Email (IMAP)</h2>
            {imapAccounts.length === 0 && (
              <div style={{ ...s.card, color: '#6b7280', fontSize: 13 }}>Brak podlaczonych kont email.</div>
            )}
            {imapAccounts.map(a => (
              <div key={a.id} style={s.card}>
                {editingImap === a.id ? (
                  <div>
                    <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 10 }}>Edytuj konto: {a.name}</div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
                      <div><label style={s.label}>Nazwa</label><input value={editImap.name} onChange={e => setEditImap({...editImap, name: e.target.value})} style={s.input} /></div>
                      <div><label style={s.label}>Serwer IMAP</label><input value={editImap.host} onChange={e => setEditImap({...editImap, host: e.target.value})} style={s.input} /></div>
                      <div><label style={s.label}>Port IMAP</label><input value={editImap.port} onChange={e => setEditImap({...editImap, port: e.target.value})} style={s.input} /></div>
                      <div><label style={s.label}>Login (email)</label><input value={editImap.login} onChange={e => setEditImap({...editImap, login: e.target.value})} style={s.input} /></div>
                      <div><label style={s.label}>Nowe haslo (zostaw puste aby nie zmieniac)</label><input type="password" value={editImap.password} onChange={e => setEditImap({...editImap, password: e.target.value})} placeholder="(bez zmian)" style={s.input} /></div>
                      <div><label style={s.label}>Serwer SMTP</label><input value={editImap.smtp_host} onChange={e => setEditImap({...editImap, smtp_host: e.target.value})} placeholder="smtp.domena.pl" style={s.input} /></div>
                      <div><label style={s.label}>Port SMTP</label><input value={editImap.smtp_port} onChange={e => setEditImap({...editImap, smtp_port: e.target.value})} placeholder="587" style={s.input} /></div>
                    </div>
                    <div style={{ display: 'flex', gap: 8 }}>
                      <button onClick={() => saveEditImap(a.id)} style={{ ...s.btn, ...s.btnPrimary }}>Zapisz</button>
                      <button onClick={() => setEditingImap(null)} style={{ ...s.btn, background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db' }}>Anuluj</button>
                    </div>
                  </div>
                ) : (
                  <div style={s.row}>
                    <div style={{ flex: 1 }}><label style={s.label}>Nazwa</label><div style={{ fontSize: 13, fontWeight: 500 }}>{a.name}</div></div>
                    <div style={{ flex: 1 }}><label style={s.label}>Login</label><div style={{ fontSize: 13, color: '#6b7280' }}>{a.login}</div></div>
                    <div style={{ flex: 1 }}><label style={s.label}>Serwer</label><div style={{ fontSize: 13, color: '#6b7280' }}>{a.host}:{a.port}</div></div>
                    <button onClick={() => { setEditingImap(a.id); setEditImap({name:a.name,host:a.host,port:a.port,login:a.login,password:'',smtp_host:a.smtp_host||'',smtp_port:a.smtp_port||'587'}); }} style={{ ...s.btn, background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe' }}>Edytuj</button>
                    <button onClick={() => deleteImap(a.id)} style={{ ...s.btn, ...s.btnDanger }}>Usun</button>
                  </div>
                )}
              </div>
            ))}
            <div style={s.card}>
              <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 12 }}>+ Dodaj konto email</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
                <div><label style={s.label}>Nazwa konta</label><input value={newImap.name} onChange={e => setNewImap({...newImap, name: e.target.value})} placeholder="np. Biuro" style={s.input} /></div>
                <div><label style={s.label}>Adres email</label><input value={newImap.login} onChange={e => setNewImap({...newImap, login: e.target.value})} placeholder="biuro@firma.pl" style={s.input} /></div>
                <div style={{ gridColumn: '1 / -1' }}><label style={s.label}>Haslo do skrzynki</label><input type="password" value={newImap.password} onChange={e => setNewImap({...newImap, password: e.target.value})} placeholder="Haslo do konta email" style={s.input} /></div>
              </div>
              {imapTestResult?.status === 'ok' && imapDetectedHost && (
                <div style={{ background: '#f0fdf4', border: '1px solid #bbf7d0', borderRadius: 6, padding: '8px 12px', fontSize: 12, color: '#15803d', marginBottom: 10 }}>
                  Wykryto IMAP: <strong>{imapDetectedHost}:{imapDetectedPort}</strong>
                  {imapDetectedSmtpHost && <span> &nbsp;|&nbsp; SMTP: <strong>{imapDetectedSmtpHost}:{imapDetectedSmtpPort}</strong></span>}
                </div>
              )}
              <div style={{ marginBottom: 8 }}>
                <details style={{ fontSize: 12, color: '#6b7280' }}>
                  <summary style={{ cursor: 'pointer', marginBottom: 6 }}>Zaawansowane (opcjonalne — wypelniane automatycznie)</summary>
                  <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 8, marginTop: 8 }}>
                    <div><label style={s.label}>Serwer IMAP</label><input value={newImap.host} onChange={e => setNewImap({...newImap, host: e.target.value})} placeholder="auto" style={s.input} /></div>
                    <div><label style={s.label}>Port IMAP</label><input value={newImap.port} onChange={e => setNewImap({...newImap, port: e.target.value})} placeholder="993" style={s.input} /></div>
                    <div><label style={s.label}>Serwer SMTP</label><input value={newImap.smtp_host} onChange={e => setNewImap({...newImap, smtp_host: e.target.value})} placeholder="smtp.domena.pl" style={s.input} /></div>
                    <div><label style={s.label}>Port SMTP</label><input value={newImap.smtp_port} onChange={e => setNewImap({...newImap, smtp_port: e.target.value})} placeholder="587" style={s.input} /></div>
                  </div>
                </details>
              </div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center', flexWrap: 'wrap' }}>
                <button onClick={testImap} disabled={imapTesting} style={{ ...s.btn, background: '#f0fdf4', color: '#15803d', border: '1px solid #bbf7d0' }}>
                  {imapTesting ? 'Testuje...' : '1. Testuj polaczenie'}
                </button>
                <button onClick={() => { addImap(); setImapTestResult(null); }} disabled={imapTestResult?.status !== 'ok'}
                  style={{ ...s.btn, ...(imapTestResult?.status === 'ok' ? s.btnPrimary : { background: '#e5e7eb', color: '#9ca3af', cursor: 'not-allowed' }) }}>
                  2. Dodaj konto
                </button>
                {imapTestResult && (
                  <span style={{ fontSize: 13, color: imapTestResult.status === 'ok' ? '#15803d' : '#dc2626', fontWeight: 500 }}>
                    {imapTestResult.status === 'ok' ? '✓ ' : '✗ '}{imapTestResult.message}
                  </span>
                )}
              </div>
            </div>
            {(currentUser?.role === 'admin' || currentUser?.can_assign) && (
              <div style={{ marginTop: 24 }}>
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                  <h3 style={{ fontSize: 15, fontWeight: 600, margin: 0 }}>Reguły automatyczne</h3>
                  <button onClick={() => setShowAddRule(v => !v)} style={{ ...s.btn, ...s.btnPrimary, fontSize: 12 }}>+ Dodaj regułę</button>
                </div>
                {showAddRule && (
                  <div style={s.card}>
                    <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 10 }}>Nowa reguła</div>
                    <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
                      <div><label style={s.label}>Nazwa reguły</label><input value={newRule.name} onChange={e => setNewRule({...newRule, name: e.target.value})} placeholder='np. Allegro powiadomienia' style={s.input} /></div>
                      <div><label style={s.label}>Konto email</label>
                        <select value={newRule.account_id} onChange={e => setNewRule({...newRule, account_id: e.target.value})} style={s.input}>
                          <option value=''>Wszystkie konta</option>
                          {imapAccounts.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                        </select>
                      </div>
                      <div><label style={s.label}>Logika</label>
                        <select value={newRule.logic} onChange={e => setNewRule({...newRule, logic: e.target.value})} style={s.input}>
                          <option value='AND'>AND — wszystkie warunki</option>
                          <option value='OR'>OR — dowolny warunek</option>
                        </select>
                      </div>
                    </div>
                    <label style={s.label}>Warunki</label>
                    {newRule.conditions.map((cond, idx) => (
                      <div key={idx} style={{ display: 'flex', gap: 6, marginBottom: 6, alignItems: 'center' }}>
                        <select value={cond.field} onChange={e => { const nc = [...newRule.conditions]; nc[idx] = {...nc[idx], field: e.target.value}; setNewRule({...newRule, conditions: nc}); }} style={{ ...s.input, flex: '0 0 110px' }}>
                          <option value='sender'>Nadawca</option>
                          <option value='subject'>Temat</option>
                        </select>
                        <select value={cond.operator} onChange={e => { const nc = [...newRule.conditions]; nc[idx] = {...nc[idx], operator: e.target.value}; setNewRule({...newRule, conditions: nc}); }} style={{ ...s.input, flex: '0 0 120px' }}>
                          <option value='contains'>zawiera</option>
                          <option value='equals'>równa się</option>
                        </select>
                        <input value={cond.value} onChange={e => { const nc = [...newRule.conditions]; nc[idx] = {...nc[idx], value: e.target.value}; setNewRule({...newRule, conditions: nc}); }} placeholder='Wartość...' style={{ ...s.input, flex: 1 }} />
                        {newRule.conditions.length > 1 && <button onClick={() => setNewRule({...newRule, conditions: newRule.conditions.filter((_,i) => i !== idx)})} style={{ ...s.btn, ...s.btnDanger, padding: '4px 8px' }}>✕</button>}
                      </div>
                    ))}
                    <div style={{ marginTop: 8, marginBottom: 8 }}>
                      <label style={s.label}>Przydziel do agenta (opcjonalnie)</label>
                      <select value={newRule.assigned_to} onChange={e => setNewRule({...newRule, assigned_to: e.target.value})} style={s.input}>
                        <option value=''>Brak — oznacz jako Zakończona</option>
                        {ruleAgents.map(a => <option key={a.id} value={a.id}>{a.name}</option>)}
                      </select>
                    </div>
                    <div style={{ display: 'flex', gap: 8, marginTop: 8 }}>
                      <button onClick={() => setNewRule({...newRule, conditions: [...newRule.conditions, {field:'sender',operator:'contains',value:''}]})} style={{ ...s.btn, background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', fontSize: 12 }}>+ Warunek</button>
                      <button onClick={async () => { if (!newRule.name || newRule.conditions.some(cd => !cd.value)) return; await axios.post(API + '/email/rules', {...newRule, account_id: newRule.account_id || null, assigned_to: newRule.assigned_to || null}); setShowAddRule(false); setNewRule({name:'',account_id:'',logic:'AND',conditions:[{field:'sender',operator:'contains',value:''}],assigned_to:''}); loadRules(); }} style={{ ...s.btn, ...s.btnPrimary }}>Zapisz</button>
                      <button onClick={() => setShowAddRule(false)} style={{ ...s.btn, background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db' }}>Anuluj</button>
                    </div>
                  </div>
                )}
                {emailRules.length === 0 && !showAddRule && <div style={{ ...s.card, color: '#6b7280', fontSize: 13 }}>Brak reguł.</div>}
                {emailRules.map(r => (
                  <div key={r.id} style={{ ...s.card, opacity: r.active ? 1 : 0.6 }}>
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', gap: 8 }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 4 }}>{r.name}</div>
                        <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>Konto: {r.account_id ? imapAccounts.find(a => a.id === r.account_id)?.name || r.account_id : 'Wszystkie'} · {r.logic} · {r.assigned_to ? (ruleAgents.find(a => a.id === r.assigned_to)?.name || 'Agent') : 'Zakończona'}</div>
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                          {(r.conditions || []).map((cd: any, i: number) => (
                            <span key={i} style={{ fontSize: 11, padding: '2px 8px', borderRadius: 10, background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe' }}>
                              {cd.field === 'sender' ? 'Nadawca' : 'Temat'} {cd.operator === 'contains' ? 'zawiera' : '='} "{cd.value}"
                            </span>
                          ))}
                        </div>
                      </div>
                      <div style={{ display: 'flex', gap: 6 }}>
                        <button onClick={async () => { await axios.patch(API + '/email/rules/' + r.id + '/toggle'); loadRules(); }} style={{ ...s.btn, background: r.active ? '#f0fdf4' : '#f3f4f6', color: r.active ? '#15803d' : '#6b7280', border: '1px solid ' + (r.active ? '#bbf7d0' : '#d1d5db'), fontSize: 12 }}>{r.active ? 'Aktywna' : 'Wył.'}</button>
                        <button onClick={async () => { await axios.delete(API + '/email/rules/' + r.id); loadRules(); }} style={{ ...s.btn, ...s.btnDanger }}>Usuń</button>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        )}

        {tab === 'knowledge' && (
          <div>
            <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>Baza wiedzy AI</h2>
            <div style={s.card}>
              <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 8 }}>Crawler strony WWW</div>
              <div style={s.row}>
                <div style={{ flex: 1 }}><input value={crawlUrl} onChange={e => setCrawlUrl(e.target.value)} style={s.input} /></div>
                <button onClick={runCrawler} style={{ ...s.btn, ...s.btnGreen }}>Skanuj strone</button>
              </div>
              {crawlStatus && <div style={{ fontSize: 12, color: '#15803d', marginTop: 8 }}>{crawlStatus}</div>}
            </div>
            <div style={s.card}>
              <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 8 }}>Wgraj FAQ</div>
              <textarea value={faqText} onChange={e => setFaqText(e.target.value)}
                placeholder="1. Pytanie&#10;1. Odpowiedz&#10;&#10;2. Pytanie&#10;2. Odpowiedz"
                style={{ ...s.input, minHeight: 160, resize: 'vertical' }} />
              <div style={{ ...s.row, marginTop: 8 }}>
                <button onClick={uploadFaq} style={{ ...s.btn, ...s.btnPrimary }}>Importuj FAQ</button>
                {faqStatus && <span style={{ fontSize: 12, color: '#15803d' }}>{faqStatus}</span>}
              </div>
            </div>
            <KnowledgeManager API={API} />
          </div>
        )}

        {tab === 'ai' && <AISettings API={API} />}
        {(tab === 'orders-settings' || tab === 'prestashop') && <OrdersSettings API={API} />}

        {tab === 'hours' && (
          <div>
            <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>Godziny pracy i auto-odpowiedzi</h2>
            <div style={s.card}>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16, marginBottom: 16 }}>
                <div><label style={s.label}>Poczatek pracy</label><input type="time" value={workHours.start} onChange={e => setWorkHours({...workHours, start: e.target.value})} style={s.input} /></div>
                <div><label style={s.label}>Koniec pracy</label><input type="time" value={workHours.end} onChange={e => setWorkHours({...workHours, end: e.target.value})} style={s.input} /></div>
              </div>
              <div style={{ marginBottom: 16 }}>
                <label style={s.label}>Dni robocze</label>
                <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', marginTop: 6 }}>
                  {[['Pon',0],['Wt',1],['Śr',2],['Czw',3],['Pt',4],['Sob',5],['Nd',6]].map(([lbl, d]) => {
                    const active = workHours.days.includes(d as number);
                    return (
                      <button key={d as number} type="button"
                        onClick={() => setWorkHours(w => ({ ...w, days: active ? w.days.filter(x => x !== d) : [...w.days, d as number] }))}
                        style={{ padding: '6px 12px', borderRadius: 8, fontSize: 13, fontWeight: 600, cursor: 'pointer',
                          border: active ? '1px solid #15803d' : '1px solid #d1d5db',
                          background: active ? '#15803d' : '#fff', color: active ? '#fff' : '#6b7280' }}>
                        {lbl}
                      </button>
                    );
                  })}
                </div>
              </div>
              <button onClick={saveWorkHours} style={{ ...s.btn, ...s.btnPrimary }}>Zapisz godziny</button>
            </div>
            <div style={s.card}>
              <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 4 }}>{'Limit cz\u0119stotliwo\u015bci natychmiastowych auto-odpowiedzi'}</div>
              <div style={{ fontSize: 11, color: '#9ca3af', marginBottom: 10 }}>{'Minimalny odst\u0119p mi\u0119dzy auto-odpowiedziami wysy\u0142anymi od razu po wiadomo\u015bci klienta (poza i w godzinach pracy) w tym samym w\u0105tku. 0 = bez limitu.'}</div>
              <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                <input type="number" min="0" step="0.5" defaultValue={appSettings.auto_reply_min_interval_hours || '0'}
                  onBlur={async e => { const v = Math.max(0, parseFloat(e.target.value) || 0); e.target.value = String(v); await axios.post(API + '/settings/app/auto_reply_min_interval_hours', { value: String(v) }); loadAll(); }}
                  style={{ ...s.input, width: 120 }} />
                <span style={{ fontSize: 12, color: '#6b7280' }}>{'godz. \u2014 np. 1 = raz na godzin\u0119, 0.5 = co p\u00f3\u0142 godziny'}</span>
              </div>
            </div>

            <div style={{ ...s.card, border: '1px solid #fca5a5', background: '#fff7f7' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 500 }}>Auto-odpowiedź poza godzinami pracy</div>
                  <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>Wysyłana gdy klient pisze poza godzinami · DOMYŚLNIE WYŁĄCZONA</div>
                </div>
                <button onClick={async () => {
                  const newVal = appSettings.afterhours_reply_enabled === 'true' ? 'false' : 'true';
                  await axios.post(API + '/settings/app/afterhours_reply_enabled', { value: newVal });
                  loadAll();
                  showSaved(newVal === 'true' ? 'Auto-odpowiedź WŁĄCZONA' : 'Auto-odpowiedź WYŁĄCZONA');
                }} style={{ ...s.btn, background: appSettings.afterhours_reply_enabled === 'true' ? '#fee2e2' : '#f0fdf4', color: appSettings.afterhours_reply_enabled === 'true' ? '#dc2626' : '#15803d', border: appSettings.afterhours_reply_enabled === 'true' ? '1px solid #fca5a5' : '1px solid #bbf7d0' }}>
                  {appSettings.afterhours_reply_enabled === 'true' ? '● WYŁĄCZ' : '● WŁĄCZ'}
                </button>
              </div>
              <label style={s.label}>Treść po polsku (wersja bazowa)</label>
              <textarea value={autoReply} onChange={e => setAutoReply(e.target.value)}
                placeholder="Dziękujemy za wiadomość. Odpowiadamy w godzinach 8:00-16:00 w dni robocze."
                style={{ ...s.input, minHeight: 80, resize: 'vertical', marginBottom: 8 }} />
              <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
                <button onClick={saveAutoReply} style={{ ...s.btn, ...s.btnPrimary }}>Zapisz PL</button>
                <button onClick={async () => { showSaved('Tłumaczę na wszystkie języki...'); await axios.get(API + '/settings/app/auto-reply-translate'); loadAll(); showSaved('Przetłumaczono!'); }} style={{ ...s.btn, ...s.btnGreen }}>🌐 Przetłumacz na wszystkie języki</button>
                <button onClick={async () => { const lang = prompt('Wpisz kod języka (np. tr, ar, pt):'); if (!lang || lang.length !== 2) return; await axios.get(API + '/settings/app/auto-reply-translate-single?lang=' + lang); loadAll(); showSaved('Przetłumaczono na ' + lang.toUpperCase()); }} style={{ ...s.btn, background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db' }}>+ Dodaj język</button>
              </div>
              {Object.keys(appSettings).filter(k => k.startsWith('auto_reply_')).map(key => {
                const lang = key.replace('auto_reply_', '');
                const flags: any = {'cs':'🇨🇿','sk':'🇸🇰','en':'🇬🇧','hu':'🇭🇺','ro':'🇷🇴','de':'🇩🇪','bg':'🇧🇬','el':'🇬🇷','nl':'🇳🇱','sv':'🇸🇪','lt':'🇱🇹','lv':'🇱🇻','et':'🇪🇪','ru':'🇷🇺','uk':'🇺🇦','fr':'🇫🇷','it':'🇮🇹','es':'🇪🇸','tr':'🇹🇷','ar':'🇸🇦','pt':'🇵🇹','pl':'🇵🇱'};
                const val = appSettings[key];
                if (!val) return null;
                return (
                  <div key={lang} style={{ marginBottom: 10 }}>
                    <label style={s.label}>{flags[lang]} {lang.toUpperCase()}</label>
                    <textarea defaultValue={val} onBlur={async e => { await axios.post(API + '/settings/app/' + key, { value: e.target.value }); }} style={{ ...s.input, minHeight: 60, resize: 'vertical' }} />
                  </div>
                );
              })}
            </div>
            <div style={{ ...s.card, border: '1px solid #bbf7d0', background: '#f0fdf4' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 500 }}>Auto-odpowiedź w godzinach pracy</div>
                  <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>Wysyłana automatycznie gdy klient pisze w godzinach pracy · DOMYŚLNIE WYŁĄCZONA</div>
                </div>
                <button onClick={async () => {
                  const newVal = appSettings.workhours_reply_enabled === 'true' ? 'false' : 'true';
                  await axios.post(API + '/settings/app/workhours_reply_enabled', { value: newVal });
                  loadAll();
                  showSaved(newVal === 'true' ? 'Auto-odpowiedź WŁĄCZONA' : 'Auto-odpowiedź WYŁĄCZONA');
                }} style={{ ...s.btn, background: appSettings.workhours_reply_enabled === 'true' ? '#fee2e2' : '#f0fdf4', color: appSettings.workhours_reply_enabled === 'true' ? '#dc2626' : '#15803d', border: appSettings.workhours_reply_enabled === 'true' ? '1px solid #fca5a5' : '1px solid #bbf7d0' }}>
                  {appSettings.workhours_reply_enabled === 'true' ? '● WYŁĄCZ' : '● WŁĄCZ'}
                </button>
              </div>
              <label style={s.label}>Treść po polsku (wersja bazowa)</label>
              <textarea defaultValue={appSettings.workhours_reply || ''} placeholder="Dziękujemy za wiadomość. Zajmiemy się Państwa sprawą wkrótce."
                onBlur={async e => { await axios.post(API + '/settings/app/workhours_reply', { value: e.target.value }); loadAll(); }}
                style={{ ...s.input, minHeight: 80, resize: 'vertical', marginBottom: 8 }} />
              <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
                <button onClick={async () => { showSaved('Tłumaczę...'); await axios.get(API + '/settings/app/workhours-reply-translate'); loadAll(); showSaved('Przetłumaczono!'); }} style={{ ...s.btn, ...s.btnGreen }}>🌐 Przetłumacz na wszystkie języki</button>
                <button onClick={async () => { const lang = prompt('Wpisz kod języka:'); if (!lang || lang.length !== 2) return; await axios.get(API + '/settings/app/workhours-reply-translate-single?lang=' + lang); loadAll(); showSaved('Przetłumaczono na ' + lang.toUpperCase()); }} style={{ ...s.btn, background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db' }}>+ Dodaj język</button>
              </div>
              {Object.keys(appSettings).filter(k => k.startsWith('workhours_reply_')).map(key => {
                const lang = key.replace('workhours_reply_', '');
                const flags: any = {'cs':'🇨🇿','sk':'🇸🇰','en':'🇬🇧','hu':'🇭🇺','ro':'🇷🇴','de':'🇩🇪','bg':'🇧🇬','el':'🇬🇷','nl':'🇳🇱','sv':'🇸🇪','lt':'🇱🇹','lv':'🇱🇻','et':'🇪🇪','ru':'🇷🇺','uk':'🇺🇦','fr':'🇫🇷','it':'🇮🇹','es':'🇪🇸','tr':'🇹🇷','ar':'🇸🇦','pt':'🇵🇹','pl':'🇵🇱'};
                const val = appSettings[key];
                if (!val) return null;
                return (
                  <div key={lang} style={{ marginBottom: 10 }}>
                    <label style={s.label}>{flags[lang]} {lang.toUpperCase()}</label>
                    <textarea defaultValue={val} onBlur={async e => { await axios.post(API + '/settings/app/' + key, { value: e.target.value }); }} style={{ ...s.input, minHeight: 60, resize: 'vertical' }} />
                  </div>
                );
              })}
            </div>
            <div style={{ ...s.card, border: '1px solid #fca5a5', background: '#fff7f7' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 500 }}>Alert po czasie bez odpowiedzi</div>
                  <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>Wysyłana gdy wiadomość czeka X godzin bez odpowiedzi · DOMYŚLNIE WYŁĄCZONA</div>
                </div>
                <button onClick={async () => {
                  const newVal = appSettings.auto_reply_enabled === 'true' ? 'false' : 'true';
                  await axios.post(API + '/settings/app/auto_reply_enabled', { value: newVal });
                  loadAll();
                  showSaved(newVal === 'true' ? 'Alert WŁĄCZONY' : 'Alert WYŁĄCZONY');
                }} style={{ ...s.btn, background: appSettings.auto_reply_enabled === 'true' ? '#fee2e2' : '#f0fdf4', color: appSettings.auto_reply_enabled === 'true' ? '#dc2626' : '#15803d', border: appSettings.auto_reply_enabled === 'true' ? '1px solid #fca5a5' : '1px solid #bbf7d0' }}>
                  {appSettings.auto_reply_enabled === 'true' ? '● WYŁĄCZ' : '● WŁĄCZ'}
                </button>
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={s.label}>Po ilu godzinach bez odpowiedzi</label>
                <input type="number" min="1" max="24" defaultValue={appSettings.alert_hours || '4'}
                  onBlur={async e => { await axios.post(API + '/settings/app/alert_hours', { value: e.target.value }); loadAll(); }}
                  style={{ ...s.input, width: 120 }} />
              </div>
              <label style={s.label}>Treść alertu po polsku (wersja bazowa)</label>
              <textarea id="alert-reply-text" defaultValue={appSettings.alert_reply_text || ''}
                placeholder="Przepraszamy za opóźnienie w odpowiedzi."
                style={{ ...s.input, minHeight: 80, resize: 'vertical', marginBottom: 8 }} />
              <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
                <button onClick={async () => { const el = document.getElementById('alert-reply-text') as HTMLTextAreaElement; await axios.post(API + '/settings/app/alert_reply_text', { value: el.value }); showSaved('Zapisano'); }} style={{ ...s.btn, ...s.btnPrimary }}>Zapisz PL</button>
                <button onClick={async () => { showSaved('Tłumaczę...'); await axios.get(API + '/settings/app/alert-reply-translate'); loadAll(); showSaved('Przetłumaczono!'); }} style={{ ...s.btn, ...s.btnGreen }}>🌐 Przetłumacz na wszystkie języki</button>
                <button onClick={async () => { const lang = prompt('Wpisz kod języka:'); if (!lang || lang.length !== 2) return; await axios.get(API + '/settings/app/alert-reply-translate-single?lang=' + lang); loadAll(); showSaved('Przetłumaczono na ' + lang.toUpperCase()); }} style={{ ...s.btn, background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db' }}>+ Dodaj język</button>
              </div>
              {Object.keys(appSettings).filter(k => k.startsWith('alert_reply_')).map(key => {
                const lang = key.replace('alert_reply_', '');
                const flags: any = {'cs':'🇨🇿','sk':'🇸🇰','en':'🇬🇧','hu':'🇭🇺','ro':'🇷🇴','de':'🇩🇪','bg':'🇧🇬','el':'🇬🇷','nl':'🇳🇱','sv':'🇸🇪','lt':'🇱🇹','lv':'🇱🇻','et':'🇪🇪','ru':'🇷🇺','uk':'🇺🇦','fr':'🇫🇷','it':'🇮🇹','es':'🇪🇸','tr':'🇹🇷','ar':'🇸🇦','pt':'🇵🇹','pl':'🇵🇱'};
                const val = appSettings[key];
                if (!val) return null;
                return (
                  <div key={lang} style={{ marginBottom: 10 }}>
                    <label style={s.label}>{flags[lang]} {lang.toUpperCase()}</label>
                    <textarea defaultValue={val} onBlur={async e => { await axios.post(API + '/settings/app/' + key, { value: e.target.value }); }} style={{ ...s.input, minHeight: 60, resize: 'vertical' }} />
                  </div>
                );
              })}
            </div>
            <div style={{ ...s.card, border: '1px solid #fed7aa', background: '#fff7ed' }}>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12 }}>
                <div>
                  <div style={{ fontSize: 13, fontWeight: 500 }}>📦 Auto-odpowiedź na zgłoszenie zwrotu</div>
                  <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>Wysyłana automatycznie gdy klient zgłosi zwrot · Użyj {"{products}"} aby wstawić listę produktów</div>
                </div>
                <button onClick={async () => {
                  const newVal = appSettings.return_auto_reply_enabled === 'true' ? 'false' : 'true';
                  await axios.post(API + '/settings/app/return_auto_reply_enabled', { value: newVal });
                  loadAll();
                  showSaved(newVal === 'true' ? 'Auto-odpowiedź na zwrot WŁĄCZONA' : 'Auto-odpowiedź na zwrot WYŁĄCZONA');
                }} style={{ ...s.btn, background: appSettings.return_auto_reply_enabled === 'true' ? '#fee2e2' : '#f0fdf4', color: appSettings.return_auto_reply_enabled === 'true' ? '#dc2626' : '#15803d', border: appSettings.return_auto_reply_enabled === 'true' ? '1px solid #fca5a5' : '1px solid #bbf7d0' }}>
                  {appSettings.return_auto_reply_enabled === 'true' ? '● WYŁĄCZ' : '● WŁĄCZ'}
                </button>
              </div>
              <label style={s.label}>Treść po polsku — użyj {'{products}'} aby wstawić listę produktów</label>
              <textarea id="return-auto-reply-text" defaultValue={appSettings.return_auto_reply || ''}
                placeholder="Przykro nam... Zwracane produkty: {products}."
                style={{ ...s.input, minHeight: 100, resize: 'vertical', marginBottom: 8 }} />
              <div style={{ display: 'flex', gap: 8, marginBottom: 16, flexWrap: 'wrap' }}>
                <button onClick={async () => { const el = document.getElementById('return-auto-reply-text') as HTMLTextAreaElement; await axios.post(API + '/settings/app/return_auto_reply', { value: el.value }); showSaved('Zapisano'); }} style={{ ...s.btn, ...s.btnPrimary }}>Zapisz PL</button>
                <button onClick={async () => { showSaved('Tłumaczę...'); await axios.get(API + '/settings/app/return-reply-translate'); loadAll(); showSaved('Przetłumaczono!'); }} style={{ ...s.btn, ...s.btnGreen }}>🌐 Przetłumacz na wszystkie języki</button>
                <button onClick={async () => { const lang = prompt('Wpisz kod języka:'); if (!lang || lang.length !== 2) return; await axios.get(API + '/settings/app/return-reply-translate-single?lang=' + lang); loadAll(); showSaved('Przetłumaczono na ' + lang.toUpperCase()); }} style={{ ...s.btn, background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db' }}>+ Dodaj język</button>
              </div>
              {Object.keys(appSettings).filter(k => k.startsWith('return_auto_reply_') && k !== 'return_auto_reply_enabled').map(key => {
                const lang = key.replace('return_auto_reply_', '');
                const flags: any = {'cs':'🇨🇿','sk':'🇸🇰','en':'🇬🇧','hu':'🇭🇺','ro':'🇷🇴','de':'🇩🇪','bg':'🇧🇬','el':'🇬🇷','nl':'🇳🇱','sv':'🇸🇪','lt':'🇱🇹','lv':'🇱🇻','et':'🇪🇪','ru':'🇷🇺','uk':'🇺🇦','fr':'🇫🇷','it':'🇮🇹','es':'🇪🇸','tr':'🇹🇷','ar':'🇸🇦','pt':'🇵🇹','pl':'🇵🇱'};
                const val = appSettings[key];
                if (!val) return null;
                return (
                  <div key={lang} style={{ marginBottom: 10 }}>
                    <label style={s.label}>{flags[lang] || lang} {lang.toUpperCase()}</label>
                    <textarea defaultValue={val} onBlur={async e => { await axios.post(API + '/settings/app/' + key, { value: e.target.value }); }} style={{ ...s.input, minHeight: 80, resize: 'vertical' }} />
                  </div>
                );
              })}
            </div>
          </div>
        )}

        {tab === 'users' && (
          <div>
            <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>Uzytkownicy</h2>
            {users.length === 0 && <div style={{ ...s.card, color: '#6b7280', fontSize: 13 }}>Brak uzytkownikow.</div>}
            {users.map(u => (
              <div key={u.id} style={s.card}>
                <div style={s.row}>
                  <div style={{ flex: 1 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                      <div style={{ width: 12, height: 12, borderRadius: '50%', background: u.color || '#9ca3af', flexShrink: 0 }} />
                      <div style={{ fontSize: 13, fontWeight: 500 }}>{u.name}</div>
                      {u.can_assign && <span style={{ fontSize: 10, padding: '1px 6px', borderRadius: 8, background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe' }}>Przydziela</span>}
                    </div>
                    <div style={{ fontSize: 12, color: '#6b7280' }}>{u.email}</div>
                    <div style={{ marginTop: 6, display: 'flex', flexWrap: 'wrap', gap: 4 }}>
                      {ALL_MODULES.map(m => (
                        <span key={m.id} style={{ fontSize: 11, padding: '2px 8px', borderRadius: 10, background: (u.modules || []).includes(m.id) ? '#eff6ff' : '#f3f4f6', color: (u.modules || []).includes(m.id) ? '#1d4ed8' : '#9ca3af', border: '1px solid ' + ((u.modules || []).includes(m.id) ? '#bfdbfe' : '#e5e7eb') }}>{m.label}</span>
                      ))}
                    </div>
                  </div>
                  <span style={{ fontSize: 11, padding: '2px 8px', borderRadius: 10, background: u.role === 'admin' ? '#eff6ff' : '#f3f4f6', color: u.role === 'admin' ? '#1d4ed8' : '#6b7280', alignSelf: 'flex-start' }}>{u.role}</span>
                  <button onClick={() => { setEditingUser(editingUser === u.id ? null : u.id); setEditUserModules(u.modules || []); setEditUserColor(u.color || '#6b7280'); setEditUserCanAssign(u.can_assign || false); setEditUserCanCrossPublish(u.can_cross_publish || false); setEditUserPhone(u.phone || ''); }} style={{ ...s.btn, background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', alignSelf: 'flex-start' }}>{editingUser === u.id ? 'Zamknij' : 'Uprawnienia'}</button>
                  <button onClick={() => deleteUser(u.id)} style={{ ...s.btn, ...s.btnDanger, alignSelf: 'flex-start' }}>Usun</button>
                </div>
                {editingUser === u.id && (
                  <div style={{ marginTop: 12, paddingTop: 12, borderTop: '1px solid #e5e7eb' }}>
                    <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 8 }}>Dostep do modulow:</div>
                    <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginBottom: 12 }}>
                      {ALL_MODULES.map(m => (
                        <span key={m.id} onClick={() => setEditUserModules(toggleMod(editUserModules, m.id))}
                          style={{ fontSize: 12, padding: '4px 12px', borderRadius: 20, cursor: 'pointer', background: editUserModules.includes(m.id) ? '#eff6ff' : '#f3f4f6', color: editUserModules.includes(m.id) ? '#1d4ed8' : '#9ca3af', border: '1px solid ' + (editUserModules.includes(m.id) ? '#bfdbfe' : '#e5e7eb'), userSelect: 'none' as const }}>
                          {editUserModules.includes(m.id) ? '✓ ' : ''}{m.label}
                        </span>
                      ))}
                    </div>
                    <div style={{ display: 'flex', gap: 16, alignItems: 'center', marginBottom: 10, flexWrap: 'wrap' }}>
                      <div>
                        <label style={s.label}>Kolor agenta</label>
                        <div style={{ display: 'flex', gap: 6, flexWrap: 'wrap', alignItems: 'center' }}>
                          {['#1d4ed8','#15803d','#dc2626','#d97706','#7c3aed','#0891b2','#be185d','#374151'].map(col => (
                            <div key={col} onClick={() => setEditUserColor(col)}
                              style={{ width: 24, height: 24, borderRadius: '50%', background: col, cursor: 'pointer',
                                border: editUserColor === col ? '3px solid #111' : '2px solid transparent',
                                boxSizing: 'border-box' as const }} />
                          ))}
                          <input type='color' value={editUserColor} onChange={e => setEditUserColor(e.target.value)}
                            style={{ width: 24, height: 24, padding: 0, border: 'none', cursor: 'pointer', borderRadius: '50%' }} />
                        </div>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                        <input type='checkbox' id={'assign-'+u.id} checked={editUserCanAssign}
                          onChange={e => setEditUserCanAssign(e.target.checked)}
                          style={{ width: 16, height: 16, cursor: 'pointer' }} />
                        <label htmlFor={'assign-'+u.id} style={{ fontSize: 13, color: '#374151', cursor: 'pointer' }}>Może przydzielać wątki</label>
                      </div>
                      <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginTop: 8 }}>
                        <input type='checkbox' id={'crosspublish-'+u.id} checked={editUserCanCrossPublish}
                          onChange={e => setEditUserCanCrossPublish(e.target.checked)}
                          style={{ width: 16, height: 16, cursor: 'pointer' }} />
                        <label htmlFor={'crosspublish-'+u.id} style={{ fontSize: 13, color: '#374151', cursor: 'pointer' }}>Wystawianie ofert na konta innych firm</label>
                      </div>
                    </div>
                    <div style={{ marginBottom: 10 }}>
                      <label style={s.label}>Telefon (do SMS)</label>
                      <input value={editUserPhone} onChange={e => setEditUserPhone(e.target.value)} placeholder="+48600123456" style={{ ...s.input, maxWidth: 200 }} />
                    </div>
                    <button onClick={() => saveUserModules(u.id, editUserModules)} style={{ ...s.btn, ...s.btnPrimary }}>Zapisz uprawnienia</button>
                  </div>
                )}
              </div>
            ))}
            <div style={s.card}>
              <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 12 }}>+ Dodaj uzytkownika</div>
              <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 10, marginBottom: 10 }}>
                <div><label style={s.label}>Imie i nazwisko</label><input value={newUser.name} onChange={e => setNewUser({...newUser, name: e.target.value})} placeholder="Jan Kowalski" style={s.input} /></div>
                <div><label style={s.label}>Email</label><input value={newUser.email} onChange={e => setNewUser({...newUser, email: e.target.value})} placeholder="jan@firma.pl" style={s.input} /></div>
                <div><label style={s.label}>Haslo</label><input type="password" value={newUser.password} onChange={e => setNewUser({...newUser, password: e.target.value})} placeholder="..." style={s.input} /></div>
                <div><label style={s.label}>Telefon (do SMS)</label><input value={newUser.phone} onChange={e => setNewUser({...newUser, phone: e.target.value})} placeholder="+48600123456" style={s.input} /></div>
                <div><label style={s.label}>Rola</label><select value={newUser.role} onChange={e => setNewUser({...newUser, role: e.target.value})} style={s.input}><option value="agent">Agent</option><option value="admin">Admin</option><option value="manager">Manager</option></select></div>
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={s.label}>Dostep do modulow:</label>
                <div style={{ display: 'flex', flexWrap: 'wrap', gap: 6, marginTop: 4 }}>
                  {ALL_MODULES.map(m => (
                    <span key={m.id} onClick={() => setNewUserModules(toggleMod(newUserModules, m.id))}
                      style={{ fontSize: 12, padding: '4px 12px', borderRadius: 20, cursor: 'pointer', background: newUserModules.includes(m.id) ? '#eff6ff' : '#f3f4f6', color: newUserModules.includes(m.id) ? '#1d4ed8' : '#9ca3af', border: '1px solid ' + (newUserModules.includes(m.id) ? '#bfdbfe' : '#e5e7eb'), userSelect: 'none' as const }}>
                      {newUserModules.includes(m.id) ? '✓ ' : ''}{m.label}
                    </span>
                  ))}
                </div>
              </div>
              <button onClick={addUser} style={{ ...s.btn, ...s.btnPrimary }}>Dodaj uzytkownika</button>
            </div>
          </div>
        )}

        {tab === 'profile' && (
          <div>
            <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>Moje konto</h2>
            <OrderNumberPrefCard />
            <div style={s.card}>
              <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 12 }}>Zmiana hasła</div>
              <div style={{ display: 'grid', gap: 10, marginBottom: 12 }}>
                <div><label style={s.label}>Obecne hasło</label><input type="password" value={changePass.old_password} onChange={e => setChangePass({...changePass, old_password: e.target.value})} placeholder="••••••••" style={s.input} /></div>
                <div><label style={s.label}>Nowe hasło (min. 8 znaków)</label><input type="password" value={changePass.new_password} onChange={e => setChangePass({...changePass, new_password: e.target.value})} placeholder="••••••••" style={s.input} /></div>
                <div><label style={s.label}>Potwierdź nowe hasło</label><input type="password" value={changePass.confirm} onChange={e => setChangePass({...changePass, confirm: e.target.value})} placeholder="••••••••" style={s.input} /></div>
              </div>
              {passStatus && (
                <div style={{ padding: '8px 12px', borderRadius: 6, fontSize: 12, marginBottom: 10, background: passStatus.includes('pomyślnie') ? '#f0fdf4' : '#fef2f2', color: passStatus.includes('pomyślnie') ? '#15803d' : '#dc2626' }}>
                  {passStatus}
                </div>
              )}
              <button onClick={changePassword} style={{ ...s.btn, ...s.btnPrimary }}>Zmień hasło</button>
            </div>
            <div style={s.card}>
              <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 12 }}>{'Stopka (podpis)'}</div>
              <label style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 10, cursor: 'pointer', fontSize: 13 }}>
                <input type="checkbox" checked={footer.enabled} onChange={e => setFooter({ ...footer, enabled: e.target.checked })} />
                {'W\u0142\u0105cz w\u0142asn\u0105 stopk\u0119'}
              </label>
              <textarea value={footer.text} onChange={e => setFooter({ ...footer, text: e.target.value })} rows={4}
                placeholder={'np. Z pozdrowieniami,\nTwoje imi\u0119'}
                style={{ ...s.input, width: '100%', boxSizing: 'border-box', resize: 'vertical', fontFamily: 'system-ui' }} />
              <div style={{ fontSize: 11, color: '#6b7280', marginTop: 6 }}>
                {'Ostatnia linia doklejana automatycznie: '}<b>{'Obs\u0142uga Klienta '}{footerMeta.account_name}</b>
              </div>
              <div style={{ marginTop: 10, padding: '10px 12px', borderRadius: 6, background: '#f9fafb', border: '1px solid #e5e7eb' }}>
                <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 4 }}>{'Podgl\u0105d stopki (doklejanej po tre\u015bci wiadomo\u015bci):'}</div>
                <div style={{ fontSize: 13, whiteSpace: 'pre-wrap', color: '#111827' }}>
                  {footer.text.trim() || '\u2026'}{'\n'}{'Obs\u0142uga Klienta '}{footerMeta.account_name}
                </div>
                {!footer.enabled && (
                  <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 4, whiteSpace: 'pre-wrap' }}>
                    {'Stopka wy\u0142\u0105czona \u2014 przy wysy\u0142ce u\u017cywana domy\u015blna: '}{footerMeta.default_text}
                  </div>
                )}
              </div>
              {Object.keys(footer.translations || {}).length > 0 && (
              <div style={{ marginTop: 10 }}>
                <div style={{ fontSize: 12, fontWeight: 500, marginBottom: 6 }}>Tłumaczenia stopki (generowane automatycznie przy zapisie)</div>
                <div style={{ fontSize: 11, color: '#6b7280', marginBottom: 8 }}>Brak tłumaczenia dla języka klienta = stopka po polsku.</div>
                <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(230px, 1fr))', gap: 8 }}>
                  {Object.keys(footer.translations || {}).sort().map(l => (
                    <div key={l} style={{ padding: '6px 8px', background: '#f9fafb', border: '1px solid #e5e7eb', borderRadius: 6 }}>
                      <div style={{ fontSize: 10, color: '#6b7280', fontWeight: 600, marginBottom: 2 }}>{LANG_LABELS[l] || l}</div>
                      <div style={{ fontSize: 12, whiteSpace: 'pre-wrap', color: '#111827' }}>{footer.translations[l]}</div>
                    </div>
                  ))}
                </div>
              </div>
              )}
              {footerStatus && <div style={{ fontSize: 12, marginTop: 8, color: footerStatus.startsWith('\u2713') ? '#15803d' : '#dc2626' }}>{footerStatus}</div>}
              <button onClick={saveFooter} style={{ ...s.btn, ...s.btnPrimary, marginTop: 10 }}>{'Zapisz stopk\u0119'}</button>
            </div>
          </div>
        )}

        {tab === 'templates' && (
          <div style={{ padding: 16 }}>
            <div style={{ fontSize: 14, fontWeight: 600, marginBottom: 12 }}>Wzory odpowiedzi</div>
            <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 16 }}>Wzory dostępne w modalu "Żądaj zwrotu" i "Decyzja reklamacyjna" w dyskusjach.</div>
            <div style={{ background: '#f9fafb', borderRadius: 8, padding: 14, marginBottom: 20, border: '1px solid #e5e7eb' }}>
              <div style={{ fontSize: 13, fontWeight: 600, marginBottom: 10 }}>{editingTemplate ? 'Edytuj wzór' : 'Dodaj nowy wzór'}</div>
              <div style={{ marginBottom: 8 }}>
                <label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 4 }}>Nazwa wzoru</label>
                <input value={templateName} onChange={e => setTemplateName(e.target.value)} placeholder="np. Zwrot – etykieta od nas" style={{ width: '100%', padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, outline: 'none', boxSizing: 'border-box' }} />
              </div>
              <div style={{ marginBottom: 8 }}>
                <label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 4 }}>Kategoria</label>
                <select value={templateCategory} onChange={e => setTemplateCategory(e.target.value)} style={{ width: '100%', padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, background: '#fff' }}>
                  <option value="return">📦 Odesłanie towaru</option>
                  <option value="decision">⚖️ Decyzja reklamacyjna</option>
                  <option value="rejection">🔄 Odrzucenie zwrotu</option>
                  <option value="general">💬 Ogólny</option>
                </select>
              </div>
              <div style={{ marginBottom: 12 }}>
                <label style={{ fontSize: 12, color: '#6b7280', display: 'block', marginBottom: 4 }}>Treść wzoru</label>
                <textarea value={templateText} onChange={e => setTemplateText(e.target.value)} placeholder="np. Prosimy o odesłanie reklamowanego towaru na adres: ..." rows={4} style={{ width: '100%', padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, fontFamily: 'system-ui', resize: 'vertical', outline: 'none', boxSizing: 'border-box' }} />
              </div>
              {templateStatus && <div style={{ fontSize: 12, color: templateStatus.includes('Błąd') ? '#dc2626' : '#15803d', marginBottom: 8 }}>{templateStatus}</div>}
              <div style={{ display: 'flex', gap: 8 }}>
                <button onClick={async () => {
                  if (!templateName.trim() || !templateText.trim()) { setTemplateStatus('Wypełnij nazwę i treść'); return; }
                  try {
                    if (editingTemplate) {
                      await axios.put(`${API}/settings/reply-templates/${editingTemplate.id}`, { name: templateName, text: templateText, category: templateCategory });
                      setTemplateStatus('Zaktualizowano!');
                    } else {
                      await axios.post(`${API}/settings/reply-templates`, { name: templateName, text: templateText, category: templateCategory });
                      setTemplateStatus('Dodano wzór!');
                    }
                    setTemplateName(''); setTemplateText(''); setTemplateCategory('rejection'); setEditingTemplate(null);
                    const res = await axios.get(`${API}/settings/reply-templates`);
                    setTemplates(res.data.templates || []);
                    setTimeout(() => setTemplateStatus(''), 2000);
                  } catch(e) { setTemplateStatus('Błąd zapisu'); }
                }} style={{ padding: '7px 16px', background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>
                  {editingTemplate ? 'Zapisz zmiany' : 'Dodaj wzór'}
                </button>
                {editingTemplate && (
                  <button onClick={() => { setEditingTemplate(null); setTemplateName(''); setTemplateText(''); setTemplateCategory('rejection'); }} style={{ padding: '7px 14px', background: 'transparent', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, cursor: 'pointer', color: '#6b7280' }}>Anuluj</button>
                )}
              </div>
            </div>
            <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 8 }}>Zapisane wzory ({templates.length})</div>
            {templates.length === 0 && <div style={{ fontSize: 12, color: '#9ca3af' }}>Brak wzorów. Dodaj pierwszy powyżej.</div>}
            {['return', 'decision', 'rejection', 'general'].map(cat => {
              const catTemplates = templates.filter(t => t.category === cat);
              if (!catTemplates.length) return null;
              const catLabel = cat === 'return' ? '📦 Odesłanie towaru' : cat === 'decision' ? '⚖️ Decyzja reklamacyjna' : cat === 'rejection' ? '🔄 Odrzucenie zwrotu' : '💬 Ogólne';
              return (
                <div key={cat} style={{ marginBottom: 16 }}>
                  <div style={{ fontSize: 12, fontWeight: 600, color: '#6b7280', marginBottom: 6 }}>{catLabel}</div>
                  {catTemplates.map(t => (
                    <div key={t.id} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: '10px 14px', marginBottom: 8 }}>
                      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                        <div style={{ flex: 1 }}>
                          <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 4 }}>{t.name}</div>
                          <div style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.5 }}>{t.text}</div>
                        </div>
                        <div style={{ display: 'flex', gap: 6, marginLeft: 10, flexShrink: 0 }}>
                          <button onClick={() => { setEditingTemplate(t); setTemplateName(t.name); setTemplateText(t.text); setTemplateCategory(t.category); }} style={{ fontSize: 11, padding: '3px 10px', borderRadius: 6, border: '1px solid #d1d5db', background: 'transparent', cursor: 'pointer', color: '#6b7280' }}>Edytuj</button>
                          <button onClick={async () => { await axios.delete(`${API}/settings/reply-templates/${t.id}`); const res = await axios.get(`${API}/settings/reply-templates`); setTemplates(res.data.templates || []); }} style={{ fontSize: 11, padding: '3px 10px', borderRadius: 6, border: '1px solid #fecaca', background: '#fef2f2', cursor: 'pointer', color: '#dc2626' }}>Usuń</button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              );
            })}
          </div>
        )}

        {tab === 'shortcuts' && (
          <div style={{ padding: 16 }}>
            <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>Skróty odpowiedzi #</h2>
            <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 16 }}>Wpisz <strong>#nazwa</strong> w polu odpowiedzi aby wkleić skrót.</div>
            <div style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 16, marginBottom: 16 }}>
              <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 10 }}>{editingShortcut ? 'Edytuj skrót' : 'Dodaj nowy skrót'}</div>
              <div style={{ display: 'flex', gap: 8, marginBottom: 8 }}>
                <input value={editingShortcut ? editingShortcut.name : shortcutName} onChange={e => editingShortcut ? setEditingShortcut({...editingShortcut, name: e.target.value}) : setShortcutName(e.target.value)} placeholder="nazwa (np. zwrot, dostawa)" style={{ width: 180, padding: '7px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13 }} />
              </div>
              <textarea value={editingShortcut ? editingShortcut.text : shortcutText} onChange={e => editingShortcut ? setEditingShortcut({...editingShortcut, text: e.target.value}) : setShortcutText(e.target.value)} placeholder="Treść skrótu..." style={{ width: '100%', minHeight: 80, padding: '8px 10px', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, resize: 'vertical', boxSizing: 'border-box', marginBottom: 8 }} />
              <div style={{ display: 'flex', gap: 8 }}>
                {editingShortcut ? (
                  <>
                    <button onClick={async () => { await axios.put(API + '/shortcuts/' + editingShortcut.id, { name: editingShortcut.name, text: editingShortcut.text }); setEditingShortcut(null); loadAll(); showSaved('Skrót zaktualizowany'); }} style={{ padding: '7px 14px', background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>Zapisz</button>
                    <button onClick={() => setEditingShortcut(null)} style={{ padding: '7px 14px', background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db', borderRadius: 6, fontSize: 13, cursor: 'pointer' }}>Anuluj</button>
                  </>
                ) : (
                  <button onClick={async () => { if (!shortcutName.trim() || !shortcutText.trim()) return; await axios.post(API + '/shortcuts', { name: shortcutName.trim(), text: shortcutText.trim() }); setShortcutName(''); setShortcutText(''); loadAll(); showSaved('Skrót dodany'); }} style={{ padding: '7px 14px', background: '#1d4ed8', color: '#fff', border: 'none', borderRadius: 6, fontSize: 13, cursor: 'pointer', fontWeight: 500 }}>+ Dodaj skrót</button>
                )}
              </div>
            </div>
            {shortcuts.length === 0 && <div style={{ color: '#9ca3af', fontSize: 13 }}>Brak skrótów. Dodaj pierwszy skrót powyżej.</div>}
            {shortcuts.map((s: any) => (
              <div key={s.id} style={{ background: '#fff', border: '1px solid #e5e7eb', borderRadius: 8, padding: 12, marginBottom: 8, display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div style={{ flex: 1 }}>
                  <div style={{ fontWeight: 600, fontSize: 13, color: '#1d4ed8', marginBottom: 4 }}>#{s.name}</div>
                  <div style={{ fontSize: 12, color: '#6b7280', whiteSpace: 'pre-wrap' }}>{s.text}</div>
                </div>
                <div style={{ display: 'flex', gap: 6, marginLeft: 12, flexShrink: 0 }}>
                  <button onClick={() => setEditingShortcut({...s})} style={{ padding: '4px 10px', background: '#eff6ff', color: '#1d4ed8', border: '1px solid #bfdbfe', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>Edytuj</button>
                  <button onClick={async () => { if (window.confirm('Usunąć skrót #' + s.name + '?')) { await axios.delete(API + '/shortcuts/' + s.id); loadAll(); showSaved('Skrót usunięty'); } }} style={{ padding: '4px 10px', background: '#fee2e2', color: '#dc2626', border: '1px solid #fca5a5', borderRadius: 6, fontSize: 12, cursor: 'pointer' }}>Usuń</button>
                </div>
              </div>
            ))}
          </div>
        )}

        {tab === 'offers' && (
          <div style={{ padding: 16 }}>
            <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>Ustawienia ofert</h2>
            <div style={{ marginBottom: 12 }}>
              <label style={s.label}>Alert niskiego stanu — próg ilości (szt.)</label>
              <input type="number" min="1" max="999" defaultValue={appSettings.stock_alert_threshold || '5'}
                onBlur={async e => { await axios.post(API + '/settings/app/stock_alert_threshold', { value: e.target.value }); loadAll(); }}
                style={{ ...s.input, width: 120 }} />
              <div style={{ fontSize: 11, color: '#6b7280', marginTop: 4 }}>Oferty z ilością równą lub mniejszą od tej wartości będą oznaczone ostrzeżeniem.</div>
            </div>
          </div>
        )}


        {tab === 'returns-alert' && (
          <div style={{ padding: 16 }}>
            <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 16 }}>Ustawienia zwrotów</h2>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 12, padding: '10px 12px', background: '#f9fafb', borderRadius: 8, border: '1px solid #e5e7eb' }}>
              <div>
                <div style={{ fontSize: 13, fontWeight: 500 }}>Alert: zwrot odebrany, nie zaakceptowany</div>
                <div style={{ fontSize: 11, color: '#9ca3af', marginTop: 2 }}>Przypomina o zwrotach, których przesyłka dotarła do Ciebie, ale nie zostały jeszcze rozpatrzone</div>
              </div>
              <button onClick={async () => {
                const newVal = appSettings.return_accept_alert_enabled === 'false' ? 'true' : 'false';
                await axios.post(API + '/settings/app/return_accept_alert_enabled', { value: newVal });
                loadAll();
                showSaved(newVal === 'true' ? 'Alert WŁĄCZONY' : 'Alert WYŁĄCZONY');
              }} style={{ ...s.btn, background: appSettings.return_accept_alert_enabled === 'false' ? '#fee2e2' : '#f0fdf4', color: appSettings.return_accept_alert_enabled === 'false' ? '#dc2626' : '#15803d', border: appSettings.return_accept_alert_enabled === 'false' ? '1px solid #fca5a5' : '1px solid #bbf7d0' }}>
                {appSettings.return_accept_alert_enabled === 'false' ? '● WYŁĄCZONY' : '● WŁĄCZONY'}
              </button>
            </div>
            <div style={{ marginBottom: 12 }}>
              <label style={s.label}>Po ilu dniach od odbioru przesyłki przez Ciebie alarmować</label>
              <input type="number" min="1" max="60" defaultValue={appSettings.return_accept_alert_days || '5'}
                onBlur={async e => { await axios.post(API + '/settings/app/return_accept_alert_days', { value: e.target.value }); loadAll(); }}
                style={{ ...s.input, width: 120 }} />
              <div style={{ fontSize: 11, color: '#6b7280', marginTop: 4 }}>Domyślnie 5 dni. Liczone od daty faktycznego odbioru przesyłki zwrotnej (nie od daty zgłoszenia zwrotu).</div>
            </div>
          </div>
        )}
        {tab === 'sales-profiles' && (
          <div style={{ padding: 0 }}>
            <SalesProfiles />
          </div>
        )}
        {tab === 'asystent' && (
          <div>
            <h2 style={{ fontSize: 16, fontWeight: 600, marginBottom: 8 }}>Asystent AI</h2>
            <div style={{ fontSize: 13, color: '#6b7280', marginBottom: 20, lineHeight: 1.6 }}>
              Asystent to pomocnik widoczny jako ikonka <strong>?</strong> w rogu ekranu. Możesz go włączyć lub wyłączyć osobno dla urządzenia mobilnego i komputera.
            </div>
            <div style={{ ...s.card, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 4 }}>📱 Asystent na telefonie (mobile)</div>
                <div style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.5 }}>Na mobile możesz przytrzymać ikonkę i przeciągnąć ją w dowolne miejsce ekranu.</div>
              </div>
              <button
                onClick={() => { const newVal = !assistantMobile; setAssistantMobile(newVal); localStorage.setItem('assistant_enabled_mobile', String(newVal)); showSaved(newVal ? 'Asystent mobile WŁĄCZONY' : 'Asystent mobile WYŁĄCZONY'); }}
                style={{ ...s.btn, minWidth: 90, marginLeft: 16, background: assistantMobile ? '#f0fdf4' : '#fee2e2', color: assistantMobile ? '#15803d' : '#dc2626', border: assistantMobile ? '1px solid #bbf7d0' : '1px solid #fca5a5' }}
              >
                {assistantMobile ? '● WŁĄCZONY' : '● WYŁĄCZONY'}
              </button>
            </div>
            {assistantMobile && (
              <div style={{ ...s.card, background: '#f9fafb', border: '1px solid #e5e7eb' }}>
                <div style={{ fontSize: 13, fontWeight: 500, marginBottom: 6 }}>Pozycja ikonki na mobile</div>
                <div style={{ fontSize: 12, color: '#6b7280', marginBottom: 12, lineHeight: 1.5 }}>Możesz przesuwać ikonkę przeciągając ją palcem. Jeśli zniknęła poza ekranem — zresetuj pozycję.</div>
                <button onClick={() => { localStorage.removeItem('assistant_pos'); showSaved('Pozycja zresetowana — odśwież stronę'); }} style={{ ...s.btn, background: '#f3f4f6', color: '#374151', border: '1px solid #d1d5db' }}>↺ Resetuj pozycję ikonki</button>
              </div>
            )}
            <div style={{ ...s.card, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
              <div>
                <div style={{ fontSize: 14, fontWeight: 500, marginBottom: 4 }}>🖥️ Asystent na komputerze (desktop)</div>
                <div style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.5 }}>Na desktopie ikonka jest zawsze w prawym dolnym rogu.</div>
              </div>
              <button
                onClick={() => { const newVal = !assistantDesktop; setAssistantDesktop(newVal); localStorage.setItem('assistant_enabled_desktop', String(newVal)); showSaved(newVal ? 'Asystent desktop WŁĄCZONY' : 'Asystent desktop WYŁĄCZONY'); }}
                style={{ ...s.btn, minWidth: 90, marginLeft: 16, background: assistantDesktop ? '#f0fdf4' : '#fee2e2', color: assistantDesktop ? '#15803d' : '#dc2626', border: assistantDesktop ? '1px solid #bbf7d0' : '1px solid #fca5a5' }}
              >
                {assistantDesktop ? '● WŁĄCZONY' : '● WYŁĄCZONY'}
              </button>
            </div>
            <div style={{ padding: '12px 16px', background: '#eff6ff', borderRadius: 8, border: '1px solid #bfdbfe', fontSize: 12, color: '#1d4ed8', lineHeight: 1.6 }}>
              💡 Ustawienia są zapisane w tej przeglądarce. Na innym urządzeniu ustawienia są niezależne.
            </div>
          </div>
        )}
      </div>
          </div>
        </div>
      )}

      {window.innerWidth < 768 && !hideHeader && (
        <div style={{ display: 'flex', background: '#1d4ed8', padding: '8px 0', paddingBottom: 'env(safe-area-inset-bottom)', flexShrink: 0 }}>
          <button onClick={onBack} style={{ flex: 1, background: 'rgba(255,255,255,0.2)', border: 'none', color: '#fff', cursor: 'pointer', padding: '6px', fontSize: 11, borderRadius: 8, margin: '0 8px' }}>
            <div style={{ fontSize: 20 }}>←</div>
            <div>Wróć</div>
          </button>
        </div>
      )}
    </div>
    </div>
  );
}
